import './App.css';
import GithubUsers from './components/GithubUsers';

function App() {
  return (
    <div>
      <GithubUsers />
    </div>
  );
}

export default App;
